import type { MeResponse } from './api'
import { getUser } from './auth'

export type CourierScope = {
  userId: string
  membershipIds: string[]
}

type UserWithMemberships = {
  id: number | string
  memberships?: Array<{ id: string; is_active?: boolean }>
}

let activeScope: CourierScope | null = null

export function setCourierScope(me: MeResponse): void {
  activeScope = {
    userId: me.user_id,
    membershipIds: me.memberships
      .filter(membership => membership.is_active && membership.role === 'courier')
      .map(membership => membership.id),
  }
}

export function getCourierScope(): CourierScope | null {
  if (activeScope) return activeScope
  const user = getUser() as UserWithMemberships | null
  if (!user) return null

  return {
    userId: String(user.id),
    membershipIds: (user.memberships ?? [])
      .filter(membership => membership.is_active !== false)
      .map(membership => membership.id),
  }
}
